/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BillingEventActionEnum } from './billingEventActionEnum';
import { BillingEventHistoryOriginEnum } from './billingEventHistoryOriginEnum';
import { BillingEventHistoryStateEnum } from './billingEventHistoryStateEnum';
import { BillingEventActionPayload } from './billingEventActionPayload';


export interface BillingEventHistoryWithIdDef { 
    id?: number;
    /**
     * Entity UUID
     */
    entity_uuid?: string;
    /**
     * Org Id of user requesting \"action\"
     */
    org_id?: string;
    /**
     * CSP Service Type of the entity
     */
    service_type?: string;
    state?: BillingEventHistoryStateEnum;
    /**
     * VCDS Service Type of the entity
     */
    vcds_service_type?: string;
    action?: BillingEventActionEnum;
    action_payload?: BillingEventActionPayload;
    /**
     * Timestamp in UTC when the event is applicable
     */
    action_timestamp?: Date;
    created_by?: BillingEventHistoryOriginEnum;
    /**
     * Timestamp in UTC when the event was inserted in table
     */
    created_timestamp?: Date;
    /**
     * Timestamp in UTC when the event was created
     */
    event_created_timestamp?: Date;
    /**
     * Timestamp in UTC when the event was updated in table
     */
    updated_timestamp?: Date;
}
export namespace BillingEventHistoryWithIdDef {
}


